<div class="pt-16 pb-16 pl-24 pr-24 font-size-20 font-weight-500 ecap-dialog-header" fxLayout="row">
    <div class="">{{ HeaderText | translate }}</div>
</div>
<div class="pt-32 pb-32 pl-24 pr-24 ng-star-inserted font-size-16" fusePerfectScrollbar fxLayout="column">
    <div fxLayout="column">
        {{ BodyText | translate }}
    </div>
</div>
<div class="modal-footer pt-12 pb-12" style="border-top: 1px solid #ededed" fxLayout="row" fxLayoutAlign="end center">
    <button
        [ngClass]="{ 'mat-raised-button mat-primary': data?.CarriedOutDialog }"
        mat-button
        color="primary"
        class="legacy-bold link text-uppercase mr-16 font-size-16"
        (click)="cancel()"
        id="am-1369"
    >
        {{ ButtonCloseText | translate }}
    </button>
</div>
